import { useContext } from 'react'

import { masterTypeName } from '@/common/app/modules/master'

import Modal from '@/components/view/layouts/modal/Modal'
import ModalHeader from '@/components/view/molecules/modal/ModalHeader'

import CsvUploadForm from '@/components/container/form/modules/master/csvUpload/CsvUploadForm'

import { CsvUploadModalContext } from './CsvUploadModalProvider'

const CsvUploadModal = () => {
  const { modal, showing, hide } = useContext(CsvUploadModalContext)

  return (
    <Modal show={showing}>
      <ModalHeader text={masterTypeName(modal.masterType) + 'を登録する'} onClickClose={hide} />
      <CsvUploadForm
        siteId={modal.siteId}
        masterType={modal.masterType}
        onClickClose={() => {
          hide()
          modal.onClose()
        }}
      />
    </Modal>
  )
}

export default CsvUploadModal
